// extracted by mini-css-extract-plugin
export default {"container":"PlaceInput_container__+BgAf","inputGroup":"PlaceInput_inputGroup__SnowW","iconWrapper":"PlaceInput_iconWrapper__XhxSY"};